import React, { Fragment } from 'react';
import { Divider, SegmentedProps } from 'antd';
import { getMenuLeftItems } from './getMenuLeftItems';
import { generatePartialPath, RoutingPage } from '../../routes/routerSlice';
import { useStableParams } from '../../routes/useStableParams';
import { styled } from 'styled-components';
import { SubmenuOption } from '../../screens/Configuration/ConfigurationHeader';
import MenuSubpageButton from './MenuSubpageButton';
import { computeRemSize } from '@ydistri/theme';

interface MenuSubpagesProps {
  routingPage: RoutingPage;
  submenuOptions: SubmenuOption[];
  selectedOption?: string;
  showInSection?: boolean;
  showFullWidth?: boolean;
  size?: SegmentedProps['size'];
  paramsToRemove?: string[];
}

const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: ${computeRemSize(8)};
`;

const OptionDivider = styled(Divider)`
  align-self: center;
  height: 2rem;
`;

const MenuSubpages: React.FC<MenuSubpagesProps> = ({
  routingPage,
  submenuOptions,
  selectedOption,
  paramsToRemove,
}) => {
  const params = useStableParams();

  return (
    <ButtonWrapper data-type="menu-subpages">
      {submenuOptions.map(option => {
        const menuItem = getMenuLeftItems().find(item => item.id === routingPage);
        if (!menuItem?.childRoute) return null;
        if (option.isVisible === false) return null;

        const paramsAfterRemoval = { ...params };
        if (paramsToRemove) {
          paramsToRemove.forEach(param => {
            if (param in paramsAfterRemoval) {
              // eslint-disable-next-line @typescript-eslint/no-dynamic-delete,@typescript-eslint/consistent-type-assertions -- needed
              delete paramsAfterRemoval[param as keyof typeof paramsAfterRemoval];
            }
          });
        }

        const partialPath = generatePartialPath(
          menuItem.childRoute,
          paramsAfterRemoval,
          option.value,
        );
        return (
          <Fragment key={option.value}>
            <MenuSubpageButton
              partialPath={partialPath}
              selected={selectedOption === option.value}
              submenuOption={option}
              disabled={option.disabled}
              data-testid={option.value}
            />
            {option.appendDivider && <OptionDivider type="vertical" />}
          </Fragment>
        );
      })}
    </ButtonWrapper>
  );
};

export default MenuSubpages;
